import { BusinessIntelligencePage } from "../misc/BusinessIntelligencePage";
import { Resource } from "react-admin";

export const businessIntelligenceResource = (
  <Resource key="bi" name="bi" list={BusinessIntelligencePage} options={{ label: "Business Intelligence" }} />
);
